import { useOrderStore } from '~~/common/stores/order';
import { useAuthenticationStore } from '~~/common/stores/authentication';
import { useConfigStore } from '~~/common/stores/config';
import { useCheckoutStore } from '~~/common/stores/checkout';
import { useDeliveryStore } from '~~/shop/app/stores/delivery';

export async function clickLogout (sendNotificationToOtherTabs = true) {
  const configStore = useConfigStore();
  const authenticationStore = useAuthenticationStore();
  const deliveryStore = useDeliveryStore();
  const orderStore = useOrderStore();
  const checkoutStore = useCheckoutStore();

  if (configStore.isSalesForceLogin) {
    authenticationStore.setCustomerDiamondLogoutIframeKey();
  }
  await authenticationStore.logout();
  if (__AW_IS_SHOP__) {
    await checkoutStore.fetchCheckout({
      type: 'FOOD',
      canStartSecondAction: true,
      canRunSimultaneous: true,
    });
  } else {
    checkoutStore.setCheckout({});
  }
  await orderStore.fetchOrder({
    id: 'current',
    canStartSecondAction: true,
    canRunSimultaneous: true,
    fetchFoodCheckout: false,
  });
  await orderStore.fetchOrderModification();

  if (__AW_IS_SHOP__) {
    await deliveryStore.fetchMethod();
    await deliveryStore.fetchTimeframes();
  }

  if (sendNotificationToOtherTabs) {
    window.localStorage.setItem(
      'clearDataInAllTabs',
      String(Number(window.localStorage.getItem('clearDataInAllTabs')) + 1),
    );
  }
}
